<template>
  <div id="playlist">
    <div class="favourite_songs allplaylist">
      <h6>System Playlist</h6>
      <div class="music_songs">
        <i class="fa fa-music"></i>
        <div class="music_title">
          Favourites
          <br />
          <span class="song_count">10 songs</span>
        </div>
        <i class="fa fa-ellipsis-v showPlayListProperTise" style="visibility: hidden;"></i>
      </div>
    </div>
    <div class="user_songs allplaylist">
      <h6>User Playlist</h6>
      <div class="music_songs">
        <i class="fa fa-music"></i>
        <div class="music_title">
          Favourites
          <br />
          <span class="song_count">10 songs</span>
        </div>
        <i class="fa fa-ellipsis-v showPlayListProperTise" style="visibility: hidden;"></i>
      </div>
    </div>
    <div class="user_songs allplaylist">
      <h6>User Playlist</h6>
      <div class="music_songs">
        <i class="fa fa-music"></i>
        <div class="music_title">
          Favourites
          <br />
          <span class="song_count">10 songs</span>
        </div>
        <i class="fa fa-ellipsis-v showPlayListProperTise" style="visibility: hidden;"></i>
      </div>
    </div>
    <div class="user_songs allplaylist">
      <h6>User Playlist</h6>
      <div class="music_songs">
        <i class="fa fa-music"></i>
        <div class="music_title">
          Favourites
          <br />
          <span class="song_count">10 songs</span>
        </div>
        <i class="fa fa-ellipsis-v showPlayListProperTise" style="visibility: hidden;"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>